import { Flex } from "antd";

import { useAppSelector } from "@/hooks/redux";
import {
    StyledInfoBlock,
    StyledInfoTitle,
    StyledProfileCard,
} from "@/pages/Profile/styles";
import { Header } from "@/shared/layout";
import { MainContainer } from "@/shared/layout/Layout";
import { Meta } from "@/shared/seo";
import { SecondaryText } from "@/shared/ui";

function Account() {
    const { firstName, lastName, phone, email } = useAppSelector(
        (state) => state.user,
    );

    return (
        <>
            <Meta title="Profile" />

            <Header title="Керування даними акаунта" />

            <MainContainer $paddingTop="48px">
                <Flex vertical gap={16}>
                    <StyledInfoTitle>Особисті дані</StyledInfoTitle>

                    <StyledProfileCard>
                        <Flex vertical gap={16}>
                            <StyledInfoBlock $borderBottom gap={12}>
                                <StyledInfoTitle>ПІБ</StyledInfoTitle>

                                <SecondaryText>
                                    {firstName} {lastName}
                                </SecondaryText>
                            </StyledInfoBlock>

                            {email && (
                                <StyledInfoBlock $borderBottom gap={12}>
                                    <StyledInfoTitle>E-mail</StyledInfoTitle>

                                    <SecondaryText>{email}</SecondaryText>
                                </StyledInfoBlock>
                            )}

                            <StyledInfoBlock>
                                <StyledInfoTitle>
                                    Номер телефону
                                </StyledInfoTitle>

                                <SecondaryText>{phone}</SecondaryText>
                            </StyledInfoBlock>
                        </Flex>
                    </StyledProfileCard>
                </Flex>
            </MainContainer>
        </>
    );
}

export default Account;
